import type { InlineUploadChatAttachment, UploadUserInputAttachments } from "@amoreg/contracts";
import { readFileAsDataUrl } from "./components/ChatView.logic";
import {
  fileAttachmentMimeType,
  reviewInlineFileAttachments,
} from "./components/chat/attachmentFiles";
import type { PendingUserInputDraftAnswer } from "./pendingUserInput";

/** Question drafts keep Files in memory; the authenticated command owns persistence. */
export async function encodeQuestionFiles(
  answers: Readonly<Record<string, PendingUserInputDraftAnswer>>,
  read: (file: File) => Promise<string> = readFileAsDataUrl,
): Promise<UploadUserInputAttachments> {
  const allFiles = Object.values(answers).flatMap((answer) => answer.files ?? []);
  const reviewed = reviewInlineFileAttachments({ files: allFiles, reservedCount: 0 });
  if (reviewed.error || reviewed.accepted.length !== allFiles.length) {
    throw new Error(reviewed.error ?? "Too many question attachments.");
  }
  const groups = await Promise.all(
    Object.entries(answers).map(
      async ([id, answer]) =>
        [
          id,
          await Promise.all(
            (answer.files ?? []).map(async (file): Promise<InlineUploadChatAttachment> => ({
              type: file.type.startsWith("image/") ? ("image" as const) : ("file" as const),
              name: file.name || "file",
              mimeType: fileAttachmentMimeType(file),
              sizeBytes: file.size,
              dataUrl: await read(file),
            })),
          ),
        ] as const,
    ),
  );
  return Object.fromEntries(groups.filter(([, files]) => files.length > 0));
}
